import { CoreExecutorResult } from "./core-executor-result.js";
/**
 * Wrap for operation specific executors. The aim is to allow for
 * function-based implementation while provide type safety and
 * package all operation execution relevant information together.
 */
export class CoreOperationExecutor {
    typeChek;
    executor;
    type;
    constructor(typeChek, executor, type) {
        this.typeChek = typeChek;
        this.executor = executor;
        this.type = type;
    }
    static create(check, executor, type) {
        return new CoreOperationExecutor(check, executor, type);
    }
    /**
     * Type agnostic operation execution function.
     */
    async execute(reader, createNewIdentifier, operation) {
        if (!this.typeChek(operation)) {
            return CoreExecutorResult.createError("Invalid operation type.");
        }
        return await this.executor(reader, createNewIdentifier, operation);
    }
}
//# sourceMappingURL=core-executor.js.map